import {Box, Button, Dialog, DialogContentText, Typography} from "@mui/material"
import {useDispatch, useSelector} from "react-redux"
import {leaveWorkspace, selectIsLeavingWorkspace, setIsLeavingWorkspace} from "../../reducers/manageWorkspaceSlice"
import {selectWorkspace} from "../../reducers/workspaceSlice"

export default function ConfirmLeaveModal() {
	const dispatch = useDispatch()
	const workspace = useSelector(selectWorkspace)
	const openModal = useSelector(selectIsLeavingWorkspace)
	return (
		<Dialog
			open={openModal}
			onClose={() => dispatch(setIsLeavingWorkspace(false))}
			PaperProps={{
				sx: {
					alignItems: "center",
					padding: "24px 32px",
					gap: "1rem",
					maxWidth: "26rem"
				}
			}}
		>
			<Typography
				sx={{
					fontWeight: 400,
					fontSize: "1.25rem",
					padding: "0",
					textAlign: "center"
				}}
			>
				Are you sure you want to leave the workspace {workspace.title}?
			</Typography>
			<DialogContentText
				sx={{
					fontSize: "1rem",
					color: "#555555",
					lineHeight: "1.375rem"
				}}
			>
				If you leave this workspace, you will be unable to join it again unless you receive a new invite.
			</DialogContentText>
			<Box
				sx={{
					width: "100%",
					display: "flex",
					flexDirection: "row",
					justifyContent: "end",
					gap: "1em",
				}}
			>
				<Button
					onClick={() => dispatch(leaveWorkspace())}
					variant={"contained"}
					color={"error"}
				>
					Leave Workspace
				</Button>
				<Button
					onClick={() => dispatch(setIsLeavingWorkspace(false))}
				>
					Cancel
				</Button>
			</Box>
		</Dialog>
	)
}